import { createAction } from 'redux-actions';

import { updateWellMutationGQL } from './graphql';


export const types = {
  OPEN_WELL_EDIT_MODAL: 'admin/wellList/OPEN_WELL_EDIT_MODAL',
  CLOSE_WELL_EDIT_MODAL: 'admin/wellList/CLOSE_WELL_EDIT_MODAL',

  OPEN_WELL_MERGE_MODAL: 'admin/wellList/OPEN_WELL_MERGE_MODAL',
  CLOSE_WELL_MERGE_MODAL: 'admin/wellList/CLOSE_WELL_MERGE_MODAL',
};


export const openWellEditModal = createAction(types.OPEN_WELL_EDIT_MODAL);
export const closeWellEditModal = createAction(types.CLOSE_WELL_EDIT_MODAL);

export const openWellMergeModal = createAction(types.OPEN_WELL_MERGE_MODAL);
export const closeWellMergeModal = createAction(types.CLOSE_WELL_MERGE_MODAL);


export const dispatchUpdateWell = (well) => {
  return async (dispatch, getState, { client }) => {
    await updateWellMutationGQL(client, well);
    dispatch(closeWellEditModal());
  };
};
